import React from "react";
import { pulp } from "./Painting/pulp.js";
import { seminal } from "./Painting/seminal.js";
import { queerIndigenous } from "./Painting/QueerIndigenous.js";
import { nothingLeft } from "./Painting/NothingLeft.js";
import { degrowth } from "./Research/Degrowth/degrowth.js";
import { anotherTime } from "./Painting/anotherTime.js";
import { withCharlotte } from "./Painting/withCharlotte.js";
import { bodiesInAlliance } from "./Curation/bodiesInAlliance.js";
import { rememberFun } from "./Curation/rememberFun.js";
import { phyto } from "./Research/phyto.js";
import { meadow } from "./Research/meadow.js";

export const About = {
  bioText: [
    "Artist and researcher.",
    "Born 1994 in Athens, Greece.",
    "Currently based in Gothenburg, Sweden.",
  ],
  button: { copy: "Download CV", url: "CV.pdf" },
  links: [
    {
      copy: "papademetriou.alexandra@gmail.com",
      url: "mailto:papademetriou.alexandra@gmail.com",
    },
    {
      copy: "@alexandra.apapa",
      url: "https://www.instagram.com/alexandra.apapa/",
    },
  ],
};

export const Work = {
  sections: [
    {
      header: "artistic research",
      variant: "gallery",
      works: [
        {
          path: "The-Active-Citizens-Guide-to-Phytoremediation",
          title: "The Active Citizen’s (Short) Guide to Phytoremediation",
          date: "2023",
          work: phyto,
        },
        {
          path: "This-box-contains-a-meadow",
          title: "This box contains a meadow",
          date: "2023",
          work: meadow,
        },
        {
          path: "The-Degrowth-Toolbox-for-Artistic-Practices",
          title: "The Degrowth Toolbox for Artistic Practices",
          date: "ongoing",
          work: degrowth,
        },
        {
          path: null,
          title:
            "The Plan for the Cultural Consolidation of the Balkan Peninsula",
          date: "2019-2021",
        },
      ],
    },
    {
      header: "painting series",
      variant: "gallery",
      works: [
        {
          path: "even-in-another-time",
          title: "…even in another time",
          date: "2022",
          work: anotherTime,
        },

        {
          path: "With-Charlotte",
          title: "With Charlotte",
          date: "2021",
          work: withCharlotte,
        },

        {
          path: "The-Handbook-to-the-Lore-and-Wisdom-of-the-Queer-Indigenous",
          title: "The Handbook to the Lore and Wisdom of the Queer Indigenous",
          date: "2017",
          work: queerIndigenous,
        },
        {
          title: "Nothing Left",
          date: "2016",
          path: "Nothing-Left",
          work: nothingLeft,
        },
        {
          title: "This Work Is Not Seminal",
          path: "This-Work-Is-Not-Seminal",
          date: "2015",
          work: seminal,
        },
        {
          title: "PULP",
          path: "PULP",
          work: pulp,
          date: "2014",
        },
      ],
    },
    {
      header: "curation",
      variant: "gallery",
      works: [
        {
          title: "Remember when this used to be fun?",
          date: "2022",
          path: "Remember-when-this-used-to-be-fun",
          work: rememberFun,
        },
        {
          title: "Bodies in Alliance / Bodies in Defiance",
          date: "2019",
          path: "Bodies-in-Alliance-Bodies-in-Defiance",
          work: bodiesInAlliance,
        },
      ],
    },
  ],
};
